/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OnboardingStepDetails } from './OnboardingStepDetails';
import {
    OnboardingStepDetailsFromJSON,
    OnboardingStepDetailsFromJSONTyped,
    OnboardingStepDetailsToJSON,
    OnboardingStepDetailsToJSONTyped,
} from './OnboardingStepDetails';

/**
 * Onboarding section for competition page
 * @export
 * @interface CompetitionOnboarding
 */
export interface CompetitionOnboarding {
    /**
     * 
     * @type {string}
     * @memberof CompetitionOnboarding
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CompetitionOnboarding
     */
    description?: string;
    /**
     * 
     * @type {Array<OnboardingStepDetails>}
     * @memberof CompetitionOnboarding
     */
    getStartedSteps?: Array<OnboardingStepDetails>;
    /**
     * 
     * @type {OnboardingStepDetails}
     * @memberof CompetitionOnboarding
     */
    instantReward?: OnboardingStepDetails;
    /**
     * 
     * @type {OnboardingStepDetails}
     * @memberof CompetitionOnboarding
     */
    prizePool?: OnboardingStepDetails;
}

/**
 * Check if a given object implements the CompetitionOnboarding interface.
 */
export function instanceOfCompetitionOnboarding(value: object): value is CompetitionOnboarding {
    return true;
}

export function CompetitionOnboardingFromJSON(json: any): CompetitionOnboarding {
    return CompetitionOnboardingFromJSONTyped(json, false);
}

export function CompetitionOnboardingFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionOnboarding {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'getStartedSteps': json['getStartedSteps'] == null ? undefined : ((json['getStartedSteps'] as Array<any>).map(OnboardingStepDetailsFromJSON)),
        'instantReward': json['instantReward'] == null ? undefined : OnboardingStepDetailsFromJSON(json['instantReward']),
        'prizePool': json['prizePool'] == null ? undefined : OnboardingStepDetailsFromJSON(json['prizePool']),
    };
}

export function CompetitionOnboardingToJSON(json: any): CompetitionOnboarding {
    return CompetitionOnboardingToJSONTyped(json, false);
}

export function CompetitionOnboardingToJSONTyped(value?: CompetitionOnboarding | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'getStartedSteps': value['getStartedSteps'] == null ? undefined : ((value['getStartedSteps'] as Array<any>).map(OnboardingStepDetailsToJSON)),
        'instantReward': OnboardingStepDetailsToJSON(value['instantReward']),
        'prizePool': OnboardingStepDetailsToJSON(value['prizePool']),
    };
}

